import { takeEvery, call, put } from 'redux-saga/effects'
import { SubmissionError } from 'redux-form'

import { updateSSO, errorSSO, SSO_GET, SSO_LINK_POST } from 'actions/sso'
import { updateUserData } from 'actions/general'
import { logInteraction } from 'util/log-interaction'

function _getSSO({ fetch }, logError) {
  return function*(action) {
    try {
      logInteraction('sso')
      const values = action.payload.values
      const orgslug = values.orgslug
      const accountEndpoint = `/auth/sso/${orgslug}`

      const ssoResult = yield call(fetch, accountEndpoint)

      yield put(
        updateSSO({
          data: ssoResult,
        })
      )
      yield put(
        updateUserData({
          portalUrl: ssoResult.returnTo,
        })
      )

      yield call(action.payload.resolve)
    } catch (err) {
      yield call(logError, err)

      const data =
        err.status === 400 && err.responseText
          ? JSON.parse(err.responseText)
          : null
      const errorData = data.msg

      if (errorData) {
        yield call(
          action.payload.reject,
          new SubmissionError({ orgslug: errorData })
        )
      } else {
        yield call(
          action.payload.reject,
          new SubmissionError({ orgslug: 'Server Error' })
        )
      }

      yield put(
        errorSSO({
          error: true,
          data: data,
        })
      )
    }
  }
}

function _postSSOLink({ create }, logError) {
  return function*(action) {
    try {
      logInteraction('sso-link')
      const values = action.payload.values
      const accountEndpoint = `/auth-link`

      const ssoResult = yield call(create, accountEndpoint, values)

      yield put(
        updateSSO({
          data: ssoResult,
        })
      )
      yield put(
        updateUserData({
          portalUrl: ssoResult.returnTo,
        })
      )

      yield call(action.payload.resolve)
    } catch (err) {
      yield call(logError, err)

      const data =
        err.status >= 400 && err.responseText
          ? JSON.parse(err.responseText)
          : null
      const errorData = data.msg

      if (errorData) {
        yield call(
          action.payload.reject,
          new SubmissionError({ _error: errorData })
        )
      } else {
        yield call(
          action.payload.reject,
          new SubmissionError({ _error: 'Server Error' })
        )
      }

      yield put(
        errorSSO({
          error: true,
          data: data,
        })
      )
    }
  }
}

export const Test = {
  _getSSO,
  _postSSOLink,
}

// Watchers
// ---------------------------------------------------------------------------
export function* watchPostSSO(api, error) {
  yield takeEvery(SSO_GET, _getSSO(api, error))
}

export function* watchPostSSOLink(api, error) {
  yield takeEvery(SSO_LINK_POST, _postSSOLink(api, error))
}
